import { render } from "./SecuritiesAcquisition.vue?vue&type=template&id=d1fe42e2&scoped=true&ts=true"
import script from "./SecuritiesAcquisition.vue?vue&type=script&lang=ts"
export * from "./SecuritiesAcquisition.vue?vue&type=script&lang=ts"

import "./SecuritiesAcquisition.vue?vue&type=style&index=0&id=d1fe42e2&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1fe42e2"]])

export default __exports__